// extracted by mini-css-extract-plugin
export default {"collection-widget":"PAQLms","collectionWidget":"PAQLms"};